import { render, staticRenderFns } from "./TableWrapper.vue?vue&type=template&id=4dadc618&scoped=true"
import script from "./TableWrapper.vue?vue&type=script&lang=js"
export * from "./TableWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dadc618",
  null
  
)

export default component.exports